import { DiamondNode, DiamondNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class InclusiveGatewayView extends DiamondNode {
  getShape() {
    const { model } = this.props;
    const { x, y, rx, ry } = model;
    void model.properties.__tv; // MobX: re-render on theme change
    const style = model.getNodeStyle();
    const points = `${x},${y - ry} ${x + rx},${y} ${x},${y + ry} ${x - rx},${y}`;

    return h('g', {}, [
      h('polygon', {
        points,
        ...style,
      }),
      // O marker (BPMN standard for Inclusive Gateway)
      h('circle', {
        cx: x,
        cy: y,
        r: 10,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 2.5,
      }),
    ]);
  }
}

class InclusiveGatewayModel extends DiamondNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.rx = 30;
    this.ry = 30;
    initLabelOffset(this, data, this.ry + 18);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'inclusiveGateway');
    style.stroke = t.stroke || '#eb2f96';
    style.strokeWidth = t.strokeWidth ?? 2;
    style.fill = t.fill || '#fff0f6';
    return style;
  }
}

export const InclusiveGateway = {
  type: 'epx:InclusiveGateway',
  view: InclusiveGatewayView,
  model: InclusiveGatewayModel,
};
